var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"load"},[_c('v-progress-linear',{attrs:{"indeterminate":"","color":"primary","height":"2"}}),_vm._v(" "),_c('div',{staticClass:"text-center text-caption px-4 pt-2"},[_vm._v("\n     Carregando mais opções...\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }